import { FeaturePageCitations } from "@/features/feature-page/feature-page-citations";
import { FeaturePageSection } from "@/features/feature-page/feature-page-section";
import { cn } from "@/lib/utils";
import type { ResolvedFeaturePageBlock } from "@garimpa/api/featurePages/types";

export function FactGridBlock({
  block,
}: {
  block: Extract<ResolvedFeaturePageBlock, { type: "factGrid" }>;
}) {
  return (
    <FeaturePageSection block={block} resolvedBackground={block.resolvedBackground}>
      {block.heading ? (
        <h2
          id={`${block.id}-heading`}
          className="mb-10 text-center text-3xl font-bold tracking-tight sm:text-5xl"
        >
          {block.heading}
        </h2>
      ) : null}
      <dl
        className={cn(
          "grid gap-4",
          block.columns === "four" ? "sm:grid-cols-2 lg:grid-cols-4" : "md:grid-cols-2",
        )}
      >
        {block.facts.map((fact) => (
          <div
            key={`${fact.label}-${fact.value}`}
            className="flex h-full flex-col rounded-2xl border border-border bg-card/85 p-6 shadow-sm backdrop-blur"
          >
            <dt className="text-xs font-bold uppercase tracking-[0.16em] text-muted-foreground">
              {fact.label}
            </dt>
            <dd className="mt-3 text-2xl font-bold">{fact.value}</dd>
            {fact.detail ? (
              <p className="mb-5 mt-3 text-sm leading-relaxed text-muted-foreground">
                {fact.detail}
              </p>
            ) : null}
            <FeaturePageCitations sourceIds={fact.sourceIds} placement="footer" />
          </div>
        ))}
      </dl>
    </FeaturePageSection>
  );
}
